import {filterByName} from './filterByName';
import {sortByName} from './sortByName';
import {sortByDateCreated} from './sortByDateCreated';

export default {
    filterByName,
    sortByName,
    sortByDateCreated
}